{
  "executiveSummary": "Coogo의 문서 생성 온톨리지는 템플릿을 구조 권위로 고정하고, LLM을 템플릿 선택·의미 합성·슬롯 채움·수정 제안에 한정한다. 이 분리는 기존 rule-only 템플릿 시스템의 경직성을 넘으면서도 최종 DOCX/PDF 생성과 검증을 결정론적으로 유지한다. 첫 평가는 동일한 Golden Template과 원본 전략 문서에 두 입력 arm을 적용하여, 실제 산출물의 유용성·근거성·편집성을 사람이 비교하는 방식으로 수행한다.",
  "pricingTable": [
    {
      "label": "Template authority",
      "value": "승격된 immutable manifest가 레이아웃, 슬롯, 입력 스키마와 산출 형식을 고정한다.",
      "evidenceRef": "source://golden-template"
    },
    {
      "label": "LLM intelligence",
      "value": "템플릿 선택, 의미 합성, 슬롯 채움, repair 후보를 제안하지만 canonical truth나 final writer가 되지 않는다.",
      "evidenceRef": "source://teacher-not-truth"
    },
    {
      "label": "Compiler evidence",
      "value": "두 arm 모두 같은 deterministic compiler를 통과하고 DOCX/PDF hash, openability, 구조 readback을 남긴다.",
      "evidenceRef": "source://deterministic-gates"
    },
    {
      "label": "Human promotion",
      "value": "자동 평가는 구조적 통과만 판정하며, 더 유용한 산출물의 선택과 ontology 승격은 실제 문서를 검토한 사람이 결정한다.",
      "evidenceRef": "source://human-promotion"
    }
  ]
}
